import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})

export class PanchakrushnaService {

  constructor(private httpClient: HttpClient) { }

  public get(id: number): Observable<PanchakrushnaVM>
  {
    return this.httpClient.get<PanchakrushnaVM>(Constants.panchakrushna + id);
  }
}

export class PanchakrushnaVM{
  panchakrushnaid:	number = 0;
  name:	string = '';
  info:	string = '';
  constructor(panchakrushnaid:	number,
    name:	string,
    info:	string)
    {
      this.panchakrushnaid = panchakrushnaid;
      this.name = name;
      this.info = info;
    }

}